import * as Actions from "../constant/ActionTypes";
import * as api from '../../api';

// Add a user entry
export const addUser = (userData) => async (dispatch) => {
    try {
        const { data } = await api.addUser(userData);

        dispatch({
            type: Actions.ADD_USER,
            payload: data
        })
    } catch (error) {
        console.log(error);
    }
}

// Update the business and role of a user
export const updateUserBusinessRole = (userData) => async (dispatch) => {
    try {
        const { data } = await api.updateUserBusinessRole(userData);

        dispatch({
            type: Actions.UPDATE_USER_BUSINESS_ROLE,
            payload: data
        })
    } catch (error) {
        console.log(error);
    }
}